/* eslint-disable consistent-return */
/* eslint-disable react/sort-comp */
import { Button, Helper, IconWithText } from 'Components';
import ID from 'helpers/id';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import React, { Fragment, PureComponent } from 'react';
import DeletionContext from 'src/MultiDeletionFunctionality/@state/DeletionStateContext';
import './Pagination.css';

class Pagination extends PureComponent {
  static contextType = DeletionContext;

  constructor(props) {
    super(props);

    this.getPages = this.getPages.bind(this);
    this.getStartingValue = this.getStartingValue.bind(this);
  }

  componentDidMount() {
    this.deletionState = this.context;
  }

  getPages() {
    const { currentPage, totalItems, itemsPerPage } = this.props;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const pages = [];
    const buffer = 2;
    const total = buffer * 2 + 1;

    if (totalPages > total) {
      if (currentPage > buffer && currentPage < totalPages - buffer) {
        for (let i = currentPage - buffer; i <= currentPage + buffer; i += 1) {
          pages.push(i);
        }
      } else if (currentPage <= buffer) {
        for (let i = 1; i <= total; i += 1) {
          pages.push(i);
        }
      } else if (currentPage >= totalPages - buffer) {
        for (let i = totalPages - total + 1; i <= totalPages; i += 1) {
          pages.push(i);
        }
      }
    } else {
      for (let i = 1; i <= totalPages; i += 1) {
        pages.push(i);
      }
    }
    return pages;
  }

  getStartingValue() {
    const { currentPage, pagesShown } = this.props;
    const middleValue = Math.floor(pagesShown / 2);

    if (currentPage < middleValue) {
      return 1;
    }

    return [];
  }

  render() {
    const { deletionState } = this.context;

    const { totalItems, itemsPerPage, currentPage } = this.props;
    const maxPage = Math.ceil(totalItems / itemsPerPage);
    const pages = this.getPages().map((page) => (
      <Button
        key={ID()}
        onClick={() => this.props.onClick(page)}
        disabled={deletionState.isDeletionModeActive}
      >
        <div
          className={`pagination__pages__page${
            currentPage === page ? '--active' : ''
          }`}
        >
          {page}
        </div>
      </Button>
    ));

    const showFirstLast = this.props.pagesShown < maxPage;

    return (
      <div className="pagination">
        {showFirstLast && (
          <IconWithText
            disabled={deletionState.isDeletionModeActive || currentPage === 1}
            onClick={(e) => {
              e.preventDefault();
              this.props.onClick(1);
            }}
            text={i18n.t('pagination:First')}
            textOrientation="after"
            icon="first_page"
          />
        )}
        {totalItems !== undefined && totalItems !== 0 && (
          <Fragment>
            <IconWithText
              disabled={deletionState.isDeletionModeActive || currentPage === 1}
              onClick={(e) => {
                e.preventDefault();
                this.props.onClick(currentPage - 1);
              }}
              text={i18n.t('pagination:Back')}
              textOrientation="after"
              icon="keyboard_arrow_left"
            />
            <div className="pagination__pages">{pages}</div>
            <Helper text={i18n.t('tutorials:pagination.1')}>
              <IconWithText
                disabled={
                  deletionState.isDeletionModeActive || currentPage === maxPage
                }
                onClick={(e) => {
                  e.preventDefault();
                  this.props.onClick(currentPage + 1);
                }}
                text={i18n.t('pagination:Next')}
                textOrientation="before"
                icon="keyboard_arrow_right"
              />
            </Helper>
          </Fragment>
        )}
        {showFirstLast && (
          <IconWithText
            disabled={
              deletionState.isDeletionModeActive || currentPage === maxPage
            }
            onClick={(e) => {
              e.preventDefault();
              this.props.onClick(maxPage);
            }}
            text={i18n.t('pagination:Last')}
            textOrientation="before"
            icon="last_page"
          />
        )}
      </div>
    );
  }
}

Pagination.propTypes = {
  onClick: PropTypes.func,
  pagesShown: (props, propName, componentName) => {
    // eslint-disable-line
    if (props[propName] % 2 === 0) {
      return new Error(
        `Invalid Prop '${propName}' supplied to '${componentName}'. Validation failed.`,
      );
    }
  },
  totalItems: PropTypes.number,
  currentPage: PropTypes.number,
  itemsPerPage: PropTypes.number,
};

Pagination.defaultProps = {
  itemsPerPage: 10,
  onClick: () => null,
  pagesShown: 5,
};

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/Pagination/Pagination.jsx